import { WAITING_FOR_INSPECTION } from "./../../../../components/contractListItem/constants";
import { ECONTRACT_STATUS } from "../../../../enums";
import { CONTRACT_BASE_URL, VOUCHER_URL } from "../../../constants";
import { getToken, isLoggedIn } from "../../../context/authContext";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IApiResponse } from "../../models";
import { CONTRACT_PATH, EXTENRAL_CONTRACT_PATH } from "./constants";
import {
  IContractDetailsBody,
  IContractDetailsResponse,
  IUpdateContractRequestBody,
  IContractActionsResponse,
  IVoucherResponse,
  IContractListResponse,
  IMilestonesPartiesData,
  IContractStatsResponse,
  UserProfile,
} from "./models";

const appProvide = async () => AuthConfig.getAppToken();
const defaultProvide = async () => await getToken();
interface CotractProps {
  listType: string;
  status?: string;
  contractId?: string;
  participantId?: string;
  referenceTransactionId?: string;
  createdAtTo?: Date | null | string;
  createdAtFrom?: Date | null | string;
  page: number;
  size: number;
  organizationCode?: string;
  type?: string;
  isFetchMilestone?: boolean;
  cashIn?: string;
  category?: string;
  operationStatus?: string;
  operationalType?: string;
  escalation?: string;
  operationResult?: string;
  shippingCompany?: string;
  cashOut?: string;
  cashOutOutType?: string;
  contractTitle?: string;
}

export const getContractDetails = (
  id: string
): Promise<IContractDetailsResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}`,
    "GET",
    isLoggedIn() ? defaultProvide : appProvide
  );
  return fetchRequest(descriptor, null);
};
export const getExternalContractDetails = (
  id: string
): Promise<IContractDetailsResponse> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/${id}`,
    "GET",
    isLoggedIn() ? defaultProvide : appProvide
  );
  return fetchRequest(descriptor, null);
};
export const getContracts = ({
  listType = "active",
  status = "",
  contractId = "",
  createdAtTo = "",
  createdAtFrom = "",
  referenceTransactionId = "",
  page = 0,
  size = 10,
  organizationCode = "",
  isFetchMilestone = false,
  cashIn = "",
  category = "",
  operationStatus = "",
  operationalType = "",
  escalation = "",
  operationResult = "",
  shippingCompany = "",
  cashOut = "",
  cashOutOutType = "",
  participantId = "",
  contractTitle = "",
}: CotractProps): Promise<IApiResponse> => {
  const statusFilter = prepareStatusFilter(listType);
  const sort = "updatedAt,desc";
  let searchKeyWord = "";
  if (contractId) searchKeyWord = contractId?.replace("+", "%2B");
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}?searchKeyWord=${searchKeyWord}&type=${
    isFetchMilestone ? "MILESTONE_CONTRACT" : "COMPLEX_CONTRACT"
  },QUICK_TRANSACTION,BROKERAGE_CONTRACT&organizationCode=${
    organizationCode ? organizationCode : "ALL"
  }&status=${
    status !== "" && status !== "ALL_CASES" ? status : statusFilter
  }&includeParent=true&createdAtTo=${createdAtTo}&createdAtFrom=${createdAtFrom}${
    referenceTransactionId &&
    `&referenceTransactionId=${referenceTransactionId}`
  }${cashIn ? `&cashIn=${cashIn}` : ""}${
    category ? `&category=${category}` : ""
  }${operationStatus ? `&operationStatus=${operationStatus}` : ""}${
    operationalType ? `&operationalType=${operationalType}` : ""
  }${escalation ? `&escalation=${escalation}` : ""}${
    operationResult ? `&operationResult=${operationResult}` : ""
  }${shippingCompany ? `&shippingCompany=${shippingCompany}` : ""}${
    cashOut ? `&cashOut=${cashOut}` : ""
  }${cashOutOutType ? `&cashOutOutType=${cashOutOutType}` : ""}${
    participantId ? `&participantId=${participantId}` : ""
  }${
    contractTitle ? `&contractTitle=${contractTitle}` : ""
  }&page=${page}&size=${size}&sort=${sort}`;

  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};
export const getExternalContracts = ({
  listType = "active",
  status = "",
  contractId = "",
  participantId = "",
  createdAtTo = "",
  createdAtFrom = "",
  referenceTransactionId = "",
  page = 0,
  size = 10,
  organizationCode = "",
  type,
}: CotractProps): Promise<IApiResponse> => {
  const statusFilter = prepareStatusFilter(listType);
  const sort = "updatedAt,desc";
  let searchKeyWord = "";
  if (contractId) searchKeyWord = contractId?.replace("+", "%2B");
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}?searchKeyWord=${searchKeyWord}&type=${type}&organizationCode=${
    organizationCode ? organizationCode : "ALL"
  }&status=${
    status !== "" && status !== "ALL_CASES" ? status : statusFilter
  }&includeParent=true&createdAtTo=${createdAtTo}&createdAtFrom=${createdAtFrom}${
    referenceTransactionId &&
    `&referenceTransactionId=${referenceTransactionId}`
  }${
    participantId && `&participantId=${participantId}`
  }&page=${page}&size=${size}&sort=${sort}`;

  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

const prepareStatusFilter = (listType: string) => {
  if (listType === "transfer") {
    const activeStatusList = [ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION];
    return activeStatusList.join();
  }
  if (listType === "active") {
    const activeStatusList = [
      ECONTRACT_STATUS.CREATED,
      ECONTRACT_STATUS.DRAFT,
      ECONTRACT_STATUS.WAITING_FOR_DELIVERY,
      ECONTRACT_STATUS.ITEM_INSPECTION,
      ECONTRACT_STATUS.DELIVERY_ESCALATION,
      ECONTRACT_STATUS.INSPECTION_ESCALATION,
      ECONTRACT_STATUS.PAID,
      ECONTRACT_STATUS.WAITING_FOR_SHIPMENT,
      ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE,
      ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE,
      ECONTRACT_STATUS.IN_PROGRESS,
      ECONTRACT_STATUS.ITEM_ACCEPTED,
      ECONTRACT_STATUS.WAITING_FOR_APPROVAL,
      ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER,
      ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER,
      ECONTRACT_STATUS.CANCELED,
      ECONTRACT_STATUS.ARCHIVED,
      ECONTRACT_STATUS.CONTRACT_ACCEPTED,
      ECONTRACT_STATUS.CONTRACT_REJECTED,
      ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION,
      ECONTRACT_STATUS.OUT_OF_STOCK,
      ECONTRACT_STATUS.PENDING_APPROVAL,
      ECONTRACT_STATUS.SUBMITTED,
      ECONTRACT_STATUS.PARTIAL_CASHOUT,
      ECONTRACT_STATUS.CASH_OUT_APPROVED,
    ];
    return activeStatusList.join();
  } else if (listType === "active_no_draft") {
    const activeStatusList = [
      ECONTRACT_STATUS.CREATED,
      ECONTRACT_STATUS.COMPLETED,
      ECONTRACT_STATUS.PARTIALLY_RELEASED,
      ECONTRACT_STATUS.PARTIALLY_PAID,
      ECONTRACT_STATUS.PARTIALLY_REFUNDED,
      ECONTRACT_STATUS.PARTIALLY_RESOLVE_RELEASED,
      ECONTRACT_STATUS.PARTIAL_CONFIRMED_DELIVERY,
      ECONTRACT_STATUS.WAITING_FOR_DELIVERY,
      ECONTRACT_STATUS.ITEM_INSPECTION,
      ECONTRACT_STATUS.DELIVERY_ESCALATION,
      ECONTRACT_STATUS.INSPECTION_ESCALATION,
      ECONTRACT_STATUS.PAID,
      ECONTRACT_STATUS.WAITING_FOR_SHIPMENT,
      ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE,
      ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE,
      ECONTRACT_STATUS.IN_PROGRESS,
      ECONTRACT_STATUS.ITEM_ACCEPTED,
      ECONTRACT_STATUS.WAITING_FOR_APPROVAL,
      ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER,
      ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER,
      ECONTRACT_STATUS.CANCELED,
      ECONTRACT_STATUS.ARCHIVED,
      ECONTRACT_STATUS.CONTRACT_ACCEPTED,
      ECONTRACT_STATUS.CONTRACT_REJECTED,
      ECONTRACT_STATUS.PENDING_PAYMENT_VERIFICATION,
      ECONTRACT_STATUS.OUT_OF_STOCK,
      ECONTRACT_STATUS.PENDING_APPROVAL,
      ECONTRACT_STATUS.SUBMITTED,
      ECONTRACT_STATUS.PARTIAL_CASHOUT,
      ECONTRACT_STATUS.CASH_OUT_APPROVED,
      ECONTRACT_STATUS.READY_FOR_CASH_OUT,
      ECONTRACT_STATUS.EXCEPTIONAL_COMPLETED,
    ];
    return activeStatusList.join();
  } else if (listType === "profile") {
    const previousStatusList = [
      ECONTRACT_STATUS.COMPLETED,
      ECONTRACT_STATUS.DELETED,
      ECONTRACT_STATUS.CREATED,
      ECONTRACT_STATUS.IN_PROGRESS,
      ECONTRACT_STATUS.DRAFT,
    ];
    return previousStatusList.join();
  } else if (listType === "profile_active") {
    const previousStatusList = [
      ECONTRACT_STATUS.DELETED,
      ECONTRACT_STATUS.CREATED,
      ECONTRACT_STATUS.IN_PROGRESS,
      ECONTRACT_STATUS.DRAFT,
    ];
    return previousStatusList.join();
  } else if (listType === "profile_finished") {
    const previousStatusList = [ECONTRACT_STATUS.COMPLETED];
    return previousStatusList.join();
  } else {
    const previousStatusList = [
      ECONTRACT_STATUS.COMPLETED,
      ECONTRACT_STATUS.CLOSED_REFUND_CUSTOMER,
      ECONTRACT_STATUS.CLOSED_RELEASE_PROVIDER,
      ECONTRACT_STATUS.EXCEPTIONAL_COMPLETED,
    ];
    return previousStatusList.join();
  }
};

export const createContractDetails = (
  body: IContractDetailsBody
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const createExternalContractDetails = (
  body: IContractDetailsBody
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const deleteContractById = (id: number | string) => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}`;
  const descriptor = new ApiServiceManager(url, "DELETE", defaultProvide);
  return fetchRequest(descriptor, null);
};

export const deleteExternalContractById = (id: number | string) => {
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/${id}`;
  const descriptor = new ApiServiceManager(url, "DELETE", defaultProvide);
  return fetchRequest(descriptor, null);
};

export const updateContractById = (
  id: string,
  body: IUpdateContractRequestBody
) => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}/item-details`;
  const descriptor = new ApiServiceManager(url, "PATCH", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const getMilestoneContracts = ({
  complexParentId,
}: {
  complexParentId: string;
}): Promise<IContractListResponse> => {
  const sort = "createdAt,ASC";
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}?parentId=${complexParentId}&sort=${sort}`;

  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getExternalMilestoneContracts = ({
  complexParentId,
  pageSize,
}: {
  complexParentId: string;
  pageSize?: number;
}): Promise<IContractListResponse> => {
  const sort = "createdAt,ASC";
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}?parentId=${complexParentId}&size=${pageSize}&sort=${sort}`;

  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getContractActions = (
  id: string
): Promise<IContractActionsResponse> => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${id}/actions`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor, null);
};

export const getContractVoucher = (
  shortId: string,
  buyerId: string
): Promise<IVoucherResponse> => {
  const url = `${VOUCHER_URL}/redemptions?domainType=CONTRACT&domainId=${shortId}&userId=${buyerId}&statuses=Redeemed,Paid,Rolledback&sort=id,DESC&size=1`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor, null);
};

export const addContractMilestonesExternal = (
  complexParentId: string,
  body: {
    milestones: Partial<IContractDetailsBody>[];
    parentContractId: string;
  }
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/${complexParentId}/milestones`;
  const descriptor = new ApiServiceManager(url, "PATCH", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const modifyContractPartiesExternal = (
  contractId: string,
  body: {
    mileStonesParties: IMilestonesPartiesData;
  }
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/${contractId}/parties`;
  const descriptor = new ApiServiceManager(url, "PATCH", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const editContractDetails = (
  body: IContractDetailsBody,
  contractId: string
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${contractId}`;
  const descriptor = new ApiServiceManager(url, "PUT", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const editExternalContractDetails = (
  body: IContractDetailsBody,
  contractId: string
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/${contractId}`;
  const descriptor = new ApiServiceManager(url, "PUT", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const editContractPartiesExternal = (
  contractId: string,
  body: {
    mileStonesParties: IMilestonesPartiesData;
  }
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/${contractId}/parties`;
  const descriptor = new ApiServiceManager(url, "PUT", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const editExternalDraftContractParties = (
  milestoneId: string,
  body: {
    parties: Partial<UserProfile>[];
  }
): Promise<IContractDetailsResponse> => {
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/${milestoneId}/draft-parties`;
  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor, body);
};

export const getContractStats = (
  milestoneId: string
): Promise<IContractStatsResponse> => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${milestoneId}/stats`;

  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const publishExternalDraftContract = (
  contractId: string
): Promise<IContractStatsResponse> => {
  const url = `${CONTRACT_BASE_URL}${EXTENRAL_CONTRACT_PATH}/${contractId}/publish`;

  const descriptor = new ApiServiceManager(url, "POST", defaultProvide);
  return fetchRequest(descriptor);
};

export const editOperationMetadata = (
  contractId: string,
  body: {
    cashIn?: string;
    category?: string;
    operationStatus?: string;
    operationalType?: string;
    escalation?: string;
    operationResult?: string;
    commisionBearer?: string;
    shippingCompany?: string;
    cashOut?: string;
    cashOutOutSystem?: string;
    cashOutOutType?: string;
    organization?: string;
    organizationWaffyFee?: string;
    organizationOperationResult?: string;
    comments?: string;
  }
): Promise<IContractStatsResponse> => {
  const url = `${CONTRACT_BASE_URL}${CONTRACT_PATH}/${contractId}/operations-metadata`;

  const descriptor = new ApiServiceManager(url, "PATCH", defaultProvide);
  return fetchRequest(descriptor, body);
};
